import React, {useEffect, useState} from 'react'
import s from './AccountTopUp.module.css'
import {Popover} from "antd";
import infoIcon from "../../../../assets/images/personalAccount/info.svg"
import CustomDropdownForAccounts from "../../../../components/ui/CustomDropdownForAccounts/CustomDropdownForAccounts";
import {useAppDispatch} from "../../../../hooks/redux";
import {Formik, useFormikContext} from "formik";
import {setFilters, setFiltersTemplates} from "../../../../store/reducers/TransactionsSlice/TransactionsSlice";
import {useSelector} from "react-redux";
import {selectAccountsByFilter, selectTopUpByAccount} from "../../../../store/reducers/TransactionsSlice/selector";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import PersonalIban from "./PersonalIban/PersonalIban";
import CorrespondentAccount from "./CorrespondentAccount/CorrespondentAccount";
import {brandConfig} from '../../../../config/config';

const AutoSubmitComponent = () => {

    const {values, submitForm} = useFormikContext();

    useEffect(() => {
        submitForm()
    }, [values, submitForm])

    return null
}

export const AccountTopUp = () => {

    const accountsList = useSelector(selectAccountsByFilter)
    const accountTopUpList = useSelector(selectTopUpByAccount)
    const dispatch = useAppDispatch()
    const [tabIndex, setTabIndex] = useState(0);

    useEffect(() => {
        const clearFilters = () => {
            dispatch(setFiltersTemplates(
                {
                    accountNumber: '',
                    period: null,
                    from: '',
                    to: '',
                    purpose: '',
                    recipient: '',
                    amount: '',
                    incoming: false,
                    outgoing: false,
                    currency: '',
                    selectedType: '',
                    templateName: '',
                    paymentRegion: ''
                }
            ))
        }

        accountTopUpList?.fortres?.forEach((item: any) => {
            if (item.isMain) {
                setTabIndex(1);
            }
        })

        return clearFilters()
    }, [accountTopUpList, dispatch])



    return (
        <div className={s.accountTopUpWrapper}>
            <Formik initialValues={{
                accountNumber: ''
            }}
                    onSubmit={(values) => {
                        dispatch(setFilters({accountNumber: values.accountNumber}))

                    }}
            >
                {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleSubmit
                  }) => (
                    <form onSubmit={handleSubmit}>
                        <div className={s.detailsWrapper}>
                            <p className={s.detailsTitle}>Details for the Bank Transfer</p>
                            <div>
                                <p className={s.labelText}>Payer account <Popover
                                    content={"Your internal account number."}
                                    color={'#EEEFEF'}
                                    placement={"bottom"}
                                    overlayInnerStyle={{
                                        fontFamily: 'Inter',
                                        padding: '13px 16px',
                                        backgroundColor: '#EEEFEF',
                                        boxShadow: 'none'
                                    }}
                                >
                                    <img src={infoIcon} alt=""/>
                                </Popover></p>
                                <CustomDropdownForAccounts
                                    items={accountsList}
                                    id='accountNumber'
                                    name='accountNumber'
                                    placeholder={"Please select the account"}
                                />
                            </div>

                            {/*accountTopUpList virtual before. now bank*/}

                            {
                                (accountTopUpList?.bank?.length > 0 || accountTopUpList?.fortres?.length > 0) &&
                                <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
                                    <TabList className={s.tabstitle_block}>
                                        {accountTopUpList?.bank?.length > 0 &&
                                            <Tab selectedClassName={s.active_tab} className={s.tabtitle}>Personal
                                                IBAN</Tab>}
                                        {accountTopUpList?.fortres?.length > 0 &&
                                            <Tab selectedClassName={s.active_tab} className={s.tabtitle}>{brandConfig.companyNameSimple}
                                                Correspondent Account</Tab>}
                                    </TabList>
                                    {
                                        accountTopUpList?.bank?.length > 0 &&
                                        <TabPanel>
                                            <PersonalIban list={accountTopUpList?.bank}/>
                                        </TabPanel>
                                    }
                                    {/*accountTopUpList virtual before. now bank*/}
                                    {
                                        accountTopUpList?.fortres?.length > 0 &&
                                        <TabPanel>
                                            <CorrespondentAccount list={accountTopUpList?.fortres}/>
                                        </TabPanel>
                                    }
                                </Tabs>
                            }
                        </div>

                        <AutoSubmitComponent/>

                    </form>
                )}
            </Formik>
        </div>
    )
}
